export default {
    add_oem_title: "Add OEM",
    add_oem_save_oem: "Save New OEM",
    add_oem_type: "Select OEM to Add",
    add_oem_cerebrumX: "CerebrumX",
    add_oem_diesellaptops: "Diesel Laptops",
    "add_oem_wex-ws" : "WEX-WS",
    add_oem_fanid:"Fan ID",
    add_oem_fanid_max:"Fan ID max value must be",
    add_oem_fanid_min:"Fan ID min value must be",
    add_oem_success_message: "OEM has been added",
    add_oem_error_message: "OEM could not be added",

}

